"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var layout_1 = require("../../../js/layout");
var render_1 = require("../../coin-animation/render");
var coin_animation_1 = require("../../coin-animation/coin-animation");
var canvas_element_1 = require("../../coin-animation/canvas-element");
var actions_1 = require("../../store/animation-playing/actions");
var cookie_helper_1 = require("../../helpers/cookie-helper");
var ChallengeComponent = (function () {
    function ChallengeComponent() {
    }
    ChallengeComponent.render = function (challenges, assets, store) {
        var _this = this;
        this.counterObj = {};
        clearInterval(this.counterInterval);
        this.element.innerHTML = '';
        if (!Object.values(challenges).length) {
            return;
        }
        Object.values(challenges).forEach(function (challenge) {
            var counter = challenge.ChallTimer;
            _this.counterObj[challenge.ChallID] = challenge;
            _this.element.innerHTML += "\n                <div class=\"coins-card coins-card-id-" + challenge.ChallID + "\" data-id=" + challenge.ChallID + ">\n                    <div class=\"coins-card-progress-bar\">\n                        <div class=\"progress progress-id-" + challenge.ChallID + "\" style=\"width:" + (String((counter * 1.66)) + '%') + "\"></div>\n                        <div class=\"progress-text\">\n                            <span class=\"progress-left-text " + challenge.ChallID + "\">" + counter + "</span>\n                            <span class=\"progress-right-text\">" + LABEL.store.round_number + " " + challenge.ChallID + "</span>\n                        </div>\n                    </div>\n                    <div class=\"coins-card-body body-id-" + challenge.ChallID + "\">\n                    <div class=\"coins-body-middle\">\n                        <canvas id=\"canvas" + challenge.ChallID + "\" ></canvas>\n                    </div>\n                        <div class=\"coins-body-left\">\n                            <div class=\"coins-body-left-upper\"><p>" + (challenge.NameP1 || '') + "</p></div>\n                            <div class=\"coins-body-left-lower\">\n                                <div class=\"coins-body-left-lower-left\">\n                                    <img src=\"img/one.svg\" alt=\"Number 1\"/>\n                                </div>\n                                <div class=\"coins-body-left-lower-right\"><p class=\"card-value\">" + (challenge.NameP1 ? challenge.TicketAmount : '') + "\n                                    </p><span class=\"card-valute\">" + (challenge.NameP1 ? cookie_helper_1.default.get('currency') || window['currency'] : '') + "</span></div>\n                            </div>\n                        </div>\n                        <div class=\"coins-body-right\">\n                            <div class=\"coins-body-right-upper\"><p>" + (challenge.NameP2 || '') + "</p></div>\n                            <div class=\"coins-body-right-lower\">\n                                <div class=\"coins-body-right-lower-left\"><p class=\"card-value\">" + (challenge.NameP2 ? challenge.TicketAmount : '') + " \n                                    </p><span class=\"card-valute\">" + (challenge.NameP2 ? cookie_helper_1.default.get('currency') || window['currency'] : '') + "</span></div>\n                                <div class=\"coins-body-right-lower-right\">\n                                    <img src=\"img/two.svg\" alt=\"Number 2\"/>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>";
            if (challenge.HeadOrTails !== 0) {
                if (_this.beginAnimated.includes(Number(challenge.ChallID))) {
                    _this.animate(challenge, assets, store);
                }
                else {
                    _this.animateBegining(challenge, assets, store);
                }
            }
        });
        this.layoutSet();
        var canvas = new render_1.default();
        canvas.renderAllElements(Object.values(challenges), this.wasAnimated);
        this.renderCounters();
        this.cleanMemory();
    };
    ChallengeComponent.layoutSet = function () {
        if (document.querySelectorAll('.coins-card')) {
            if (document.querySelectorAll('.coins-card').length > 43) {
                return;
            }
            else {
                if (window.innerWidth > 1199) {
                    layout_1.checkCardsLength();
                }
                else {
                    layout_1.checkMediumLength();
                }
            }
        }
    };
    ChallengeComponent.renderCounters = function () {
        var _this = this;
        this.counterInterval = window.setInterval(function () {
            Object.keys(_this.counterObj).forEach(function (obj) {
                if (_this.counterObj[obj].ChallTimer > -1) {
                    document.getElementsByClassName("progress-left-text " + _this.counterObj[obj].ChallID) ?
                        document.getElementsByClassName("progress-left-text " + _this.counterObj[obj].ChallID)[0] ?
                            document.getElementsByClassName("progress-left-text " + _this.counterObj[obj].ChallID)[0].innerHTML =
                                String(_this.counterObj[obj].ChallTimer)
                            : '' : '';
                    document.getElementsByClassName("progress progress-id-" + _this.counterObj[obj].ChallID) ?
                        document.getElementsByClassName("progress progress-id-" + _this.counterObj[obj].ChallID)[0] ?
                            document.getElementsByClassName("progress progress-id-" + _this.counterObj[obj].ChallID)[0].style.width =
                                String((_this.counterObj[obj].ChallTimer * 1.66)) + '%'
                            : '' : '';
                }
                else {
                    _this.counterObj[obj].ChallTimer = 0;
                }
                _this.counterObj[obj].ChallTimer--;
            });
        }, 1000);
    };
    ChallengeComponent.cleanMemory = function () {
        if (this.beginAnimated.length > 100) {
            this.beginAnimated.splice(0, 50);
        }
        if (this.wasAnimated.length > 100) {
            this.wasAnimated.splice(0, 50);
        }
    };
    ChallengeComponent.animate = function (challenge, assets, store) {
        var canvasElement = (new canvas_element_1.default("canvas" + challenge.ChallID));
        if (canvasElement) {
            if (this.wasAnimated.includes(challenge.ChallID)) {
                return;
            }
            else {
                document.querySelector("div.coins-card-id-" + challenge.ChallID + " .coins-body-left-upper p").innerHTML =
                    challenge.NameP1 || 'Computer';
                document.querySelector("div.coins-card-id-" + challenge.ChallID + " .coins-body-right-upper p").innerHTML =
                    challenge.NameP2 || 'Computer';
                document.querySelector("div.coins-card-id-" + challenge.ChallID + " .coins-body-left-lower-right p").innerHTML =
                    String(challenge.TicketAmount);
                document.querySelector("div.coins-card-id-" + challenge.ChallID + " .coins-body-right-lower-left p").innerHTML =
                    String(challenge.TicketAmount);
                document.querySelector("div.coins-card-id-" + challenge.ChallID + " .coins-body-left-lower-right .card-valute").innerHTML =
                    cookie_helper_1.default.get('currency') || window['currency'];
                document.querySelector("div.coins-card-id-" + challenge.ChallID + " .coins-body-right-lower-left .card-valute").innerHTML =
                    cookie_helper_1.default.get('currency') || window['currency'];
                store.dispatch(actions_1.setPlayAnimation(true));
                this.coinAnimation = new coin_animation_1.default(assets, store);
                this.coinAnimation.animateCoinIn(canvasElement, challenge.HeadOrTails, Number(challenge.ChallID));
                this.wasAnimated.push(challenge.ChallID);
            }
        }
    };
    ChallengeComponent.animateBegining = function (challenge, assets, store) {
        var _this = this;
        document.querySelector(".coins-card-id-" + challenge.ChallID) ?
            document.querySelector(".coins-card-id-" + challenge.ChallID).classList.add('my-glower') : '';
        this.beginAnimated.indexOf(Number(challenge.ChallID)) === -1 ? this.beginAnimated.push(Number(challenge.ChallID)) : '';
        document.querySelector("div.coins-card-id-" + challenge.ChallID + " .coins-body-left-upper p").innerHTML =
            challenge.NameP1 || 'Computer';
        document.querySelector("div.coins-card-id-" + challenge.ChallID + " .coins-body-right-upper p").innerHTML =
            challenge.NameP2 || 'Computer';
        document.querySelector("div.coins-card-id-" + challenge.ChallID + " .coins-body-left-lower-right p").innerHTML =
            String(challenge.TicketAmount);
        document.querySelector("div.coins-card-id-" + challenge.ChallID + " .coins-body-right-lower-left p").innerHTML =
            String(challenge.TicketAmount);
        document.querySelector("div.coins-card-id-" + challenge.ChallID + " .coins-body-left-lower-right .card-valute").innerHTML =
            cookie_helper_1.default.get('currency') || window['currency'];
        document.querySelector("div.coins-card-id-" + challenge.ChallID + " .coins-body-right-lower-left .card-valute").innerHTML =
            cookie_helper_1.default.get('currency') || window['currency'];
        setTimeout(function () {
            _this.animate(challenge, assets, store);
        }, 3500);
    };
    ChallengeComponent.element = document.getElementById('coinTable');
    ChallengeComponent.wasAnimated = [];
    ChallengeComponent.beginAnimated = [];
    ChallengeComponent.counterObj = {};
    ChallengeComponent.counterInterval = 0;
    return ChallengeComponent;
}());
exports.default = ChallengeComponent;



//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/ts/components/card/challenge.ts
// module id = 1996
// module chunks = 4